import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const Lightbox = ({ img, onClose }) => (
  <AnimatePresence>
    {img && (
      <motion.div
        data-testid="lightbox-overlay"
        className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 md:p-12"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
        onClick={onClose}
      >
        <motion.figure
          initial={{ scale: 0.94, y: 12 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.96, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-5xl w-full border border-[#F4F4F0]/50 bg-[#0E0E0E]"
          onClick={(e) => e.stopPropagation()}
        >
          <figcaption className="font-mono text-[10px] md:text-xs uppercase tracking-widest px-4 py-3 border-b border-[#F4F4F0]/30 flex justify-between items-center text-[#F4F4F0]">
            <span>{img.label}</span>
            <button
              data-testid="lightbox-close-btn"
              onClick={onClose}
              aria-label="Close"
              className="hover:text-[#FF3B30] transition-colors duration-200"
            >
              <X size={18} />
            </button>
          </figcaption>
          <img src={img.src} alt={img.label} className="w-full max-h-[72vh] object-contain bg-[#0E0E0E]" />
        </motion.figure>
      </motion.div>
    )}
  </AnimatePresence>
);
